<script lang="ts">
  import ContentContainer from "../components/content-box-system/ContentContainer.svelte";
  import ContentSection from "../components/content-box-system/ContentSection.svelte";
  import DiscordServerWidget from "../components/DiscordServerWidget.svelte";
  import { loadContent } from "../loader";
</script>

<main>
  <ContentContainer classNames="pure-g">
    <div class="pure-u-1-1 pure-u-md-5-12 col-2">
      <ContentSection content={loadContent("Home.md")} />
    </div>
    <div class="pure-u-1-1 pure-u-md-1-6 col-1">
      <ContentSection
        content={loadContent("Home_clancommunity.md", {
          preserveWhitespace: true,
        })}
      />
    </div>
    <div class="pure-u-1-1 pure-u-md-5-12 col-3">
      <ContentSection title="Discord Server">
        <DiscordServerWidget />
      </ContentSection>
    </div>
  </ContentContainer>
</main>

<style lang="scss">
  @media screen and (min-width: 48em) {
    .col-1 {
      order: 1;
    }
    .col-2 {
      order: 2;
    }
    .col-3 {
      order: 3;
    }
  }
</style>
